//  +----------------------------------------------------------------------
//  | 球友会 [ 关于台球，就用球友汇 ]
//  +----------------------------------------------------------------------
//  | Copyright (c) 2025 https://www.qyxtyfz.com All rights reserved.
//  +----------------------------------------------------------------------

import {
	HTTP_REQUEST_URL,
	HEADER,
	TOKENNAME,
	HEADERPARAMS
} from '@/config/app';
import {
	toLogin,
	checkLogin,
	refreshExpires
} from '../libs/login';
import store from '../store';
import util from './util';


/**
 * 发送请求
 */
function baseRequest(url, method, data, {
	noAuth = false,
	noVerify = false,
	noRedirect = false
}, params,prefix) {
	let Url = HTTP_REQUEST_URL,header = HEADER
	if (params != undefined) {
		header = HEADERPARAMS;
	}
	if (!noAuth) {
		//登录过期自动登录
		if (!store.state.app.token && !checkLogin()) {
			toLogin();
			return Promise.reject({
				msg: '未登录'
			});
		}
	}
	if (store.state.app.token) header[TOKENNAME] = store.state.app.token;
	return new Promise((reslove, reject) => {
		uni.request({
			url: Url + `${prefix?'/api/public/':'/api/front/'}` + url,
			method: method || 'GET',
			header: header,
			data: data || {},
			success: (res) => {
				// 用响应头 Date 同步服务器时间，修正设备时钟偏差对相对时间显示的影响
				if (res.header) util.syncServerTime(res.header.Date || res.header.date);
				if (noVerify)
					reslove(res.data, res);
				else if (res.data.code == 200) {
					refreshExpires();
					reslove(res.data, res);
				}
			else if ([410000, 410001, 410002, 401,402].indexOf(res.data.code) !== -1) {
				if (!noRedirect) toLogin();
				reject(res.data);
			}else if (res.data.code == 500){
					reject(res.data.message || '系统异常');
				}else if (res.data.code == 400){
					reject(res.data.message || '参数校验失败');
				}else if (res.data.code == 404){
					reject(res.data.message || '没有找到相关数据');
				}else if (res.data.code == 403){
					reject(res.data.message || '没有相关权限');
				} else
					reject(res.data.message || '系统错误');
			},
			fail: (msg) => {
				reject('请求失败');
			}
		})
	});
}

const request = {};

['options', 'get', 'post', 'put', 'head', 'delete', 'trace', 'connect'].forEach((method) => {
	request[method] = (api, data, opt, params,prefix) => baseRequest(api, method, data, opt || {}, params,prefix)
});



export default request;
